import { FC, memo } from 'react';

import classNames from 'classnames';

import { COMMON_TEST_ID } from '@telialt/test/src/test-ids';

import { IconProps } from './model';

export type Props = IconProps & { ariaLabel?: string };

const Icon: FC<Props> = ({ className, style, ariaLabel, type }) => {
    const iconType = type.replace('icon-', '');
    const styles = style !== undefined ? { ...style } : {};
    const classList = classNames('icon', `icon-${iconType}`, className);

    const ariaAttributes = ariaLabel ? { 'aria-label': ariaLabel } : { 'aria-hidden': true };

    return (
        <i className={classList} {...ariaAttributes} style={styles} data-test={`${COMMON_TEST_ID.ICON}-${iconType}`} />
    );
};

export default memo(Icon);
